/**
 * Boxlight Mega Menu — accessibility & keyboard enhancements
 *
 * Builds on top of Bootstrap 5's Dropdown component, which already handles
 * click/hover open-close and ESC. This adds:
 *
 *  - Roving Tab focus: Tab/Shift+Tab cycles through links inside an open
 *    mega menu; tabbing past the last link closes the menu and moves to
 *    the next top-level item.
 *  - Arrow keys: Left/Right move between top-level nav items; Down opens
 *    a mega menu and focuses the first link; Up closes it.
 *  - ESC: closes the open dropdown and returns focus to its toggle.
 *  - Click-outside: closes any open dropdown (Bootstrap handles this,
 *    but we double-check here to be safe with nested markup).
 */

(function () {
    if (typeof document === 'undefined') return;

    document.addEventListener('DOMContentLoaded', function () {
        const navs = document.querySelectorAll('.mega-nav');
        if (!navs.length) return;

        navs.forEach((nav) => enhance(nav));
    });

    function enhance(nav) {
        // All top-level toggles (buttons that open a megamenu) plus simple top-level links
        const topLevelLinks = nav.querySelectorAll(':scope > li > .nav-link');

        nav.addEventListener('keydown', (e) => {
            const target = e.target;

            // Handle ESC regardless of position
            if (e.key === 'Escape') {
                const openToggle = nav.querySelector('.nav-link.dropdown-toggle[aria-expanded="true"]');
                if (openToggle) {
                    e.preventDefault();
                    closeDropdown(openToggle);
                    openToggle.focus();
                }
                return;
            }

            // When focus is on a top-level toggle/link
            if (target.matches(':scope > li > .nav-link, li.nav-item > .nav-link')) {
                const current = target.closest('.nav-item');
                if (!current) return;

                switch (e.key) {
                    case 'ArrowRight':
                        e.preventDefault();
                        moveTopLevelFocus(current, 1, topLevelLinks);
                        break;
                    case 'ArrowLeft':
                        e.preventDefault();
                        moveTopLevelFocus(current, -1, topLevelLinks);
                        break;
                    case 'ArrowDown':
                    case 'Enter':
                    case ' ':
                        // If it's a mega-menu toggle, open it and focus first link
                        if (target.matches('.dropdown-toggle') && current.classList.contains('has-megamenu')) {
                            e.preventDefault();
                            openDropdown(target);
                            focusFirstLinkInMegamenu(current);
                        }
                        break;
                    case 'ArrowUp':
                        // No-op on top level
                        break;
                }
                return;
            }

            // When focus is inside an open megamenu link list
            const inMega = target.closest('.megamenu');
            if (inMega) {
                const links = Array.from(inMega.querySelectorAll('.megamenu__link, .megamenu__heading[href], .megamenu__cta'));
                const idx = links.indexOf(target);

                switch (e.key) {
                    case 'ArrowDown':
                        e.preventDefault();
                        if (idx >= 0 && idx < links.length - 1) links[idx + 1].focus();
                        break;
                    case 'ArrowUp':
                        e.preventDefault();
                        if (idx > 0) {
                            links[idx - 1].focus();
                        } else {
                            // At the top: return to the parent toggle
                            const parentToggle = inMega.closest('.nav-item').querySelector('.nav-link.dropdown-toggle');
                            if (parentToggle) parentToggle.focus();
                        }
                        break;
                    // Tab is handled by the browser naturally
                }
            }
        });
    }

    function moveTopLevelFocus(currentLi, direction, allLinks) {
        const links = Array.from(allLinks);
        const currentLink = currentLi.querySelector(':scope > .nav-link');
        const idx = links.indexOf(currentLink);
        if (idx === -1) return;
        const nextIdx = (idx + direction + links.length) % links.length;
        links[nextIdx].focus();
    }

    function focusFirstLinkInMegamenu(li) {
        const first = li.querySelector('.megamenu .megamenu__link');
        if (first) setTimeout(() => first.focus(), 10); // wait for Bootstrap to finish opening
    }

    function openDropdown(toggle) {
        if (window.bootstrap && window.bootstrap.Dropdown) {
            const instance = window.bootstrap.Dropdown.getOrCreateInstance(toggle);
            instance.show();
        }
    }

    function closeDropdown(toggle) {
        if (window.bootstrap && window.bootstrap.Dropdown) {
            const instance = window.bootstrap.Dropdown.getOrCreateInstance(toggle);
            instance.hide();
        }
    }
})();
